<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.368 4.78999L5.632 3.87699C5.33133 3.77684 5.01118 3.74958 4.69791 3.79745C4.38464 3.84532 4.08723 3.96694 3.83019 4.1523C3.57315 4.33766 3.36383 4.58145 3.21949 4.86357C3.07516 5.1457 2.99992 5.45808 3 5.77499V17.558C2.9999 17.9779 3.13198 18.3872 3.37752 18.7279C3.62305 19.0686 3.96959 19.3233 4.368 19.456L8.368 20.789C8.77825 20.9256 9.22175 20.9256 9.632 20.789L14.368 19.211C14.7783 19.0743 15.2217 19.0743 15.632 19.211L18.368 20.123C18.6687 20.2232 18.989 20.2504 19.3023 20.2025C19.6157 20.1546 19.9132 20.0329 20.1702 19.8474C20.4273 19.6619 20.6366 19.418 20.7808 19.1357C20.9251 18.8535 21.0002 18.541 21 18.224V6.44199C21.0002 6.02218 20.8682 5.61296 20.6229 5.27231C20.3775 4.93166 20.0312 4.67685 19.633 4.54399L15.633 3.21099C15.2224 3.07412 14.7786 3.07412 14.368 3.21099L9.631 4.78899C9.22074 4.92563 8.77725 4.92563 8.367 4.78899L8.368 4.78999Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 2.99994V18.4767M9 4.93454V20.4113V4.93454Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
</template>
